export default "__VITE_ASSET__CK3jBsP0__";